const nonEmpty = (value) => String(value || '').trim().length > 0

const hasAnyText = (data, keys) => keys.some((key) => nonEmpty(data?.[key]))

const hasArrayItems = (value) => Array.isArray(value) && value.length > 0

export function isPublicCardConfigured(data = {}) {
  if (!data) return false

  if (String(data.cardTemplateId || 'CARD_V1').toUpperCase() !== 'CARD_V1') return true
  if (data.showLandingLink === false) return true
  if (data.showCareerCard === false) return true
  if (data.showActivityAreaCard === false) return true
  if (data.showFreeTextCard === false) return true
  if (data.imageCardEnabled === true) return true
  if (hasArrayItems(data.cardTimeline)) return true

  return hasAnyText(data, [
    'bioShort',
    'introTextOverride',
    'introText',
    'careerText',
    'activityAreaText',
    'freeText',
    'kakaoChatUrl',
    'profileImageFileId',
    'profileImageUrl',
    'cardOrgLogoFileId',
    'cardOrgLogoUrl',
    'companyNameOverride',
    'jobTitleOverride',
    'addressTextOverride',
    'mobileFaxNumberOverride',
    'serviceTags',
    'youtubeUrl',
    'instagramUrl',
    'blogUrl',
    'imageCardFileId',
    'imageCardUrl',
  ])
}

export function isPersonalLandingConfigured(data = {}) {
  if (!data) return false

  if (hasArrayItems(data.landingSections)) return true
  if (String(data.landingTemplateId || 'LANDING_V1').toUpperCase() !== 'LANDING_V1') return true
  if (data.landingGalleryEnabled === true) return true
  if (hasArrayItems(data.landingGalleryItems) || hasArrayItems(data.landingGalleryUrls)) return true
  if (data.landingPageStyle && typeof data.landingPageStyle === 'object' && Object.keys(data.landingPageStyle).length > 0) return true

  return false
}
